import VerificationPage from './VerificationPage'

export default VerificationPage
